module.exports = __webpack_public_path__ + "img/logo-wordmark-dark.6bf7e2be.svg";